import { CallRecordKey } from 'flow/types/EntityKeys';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectCallRecordRecordingDownloadUrl } from 'flow/selectors/call-records-selectors';
import { homeActionUrlPath } from 'flow/utils';
import useAppContext from 'flow/hooks/useAppContext';
import Icon from 'flow/components/ui-components/Icon';
import MenuItem from 'flow/components/ui-components/MenuItem';

interface Props {
    callRecordKey: CallRecordKey;
    onClickDownloadRecording?: () => void;
}

const MenuItemDownloadRecording = ({
    callRecordKey,
    onClickDownloadRecording,
}: Props) => {
    const { i18next } = useAppContext();
    const downloadUrl = useAppSelector((state) =>
        selectCallRecordRecordingDownloadUrl(state, callRecordKey),
    );

    if (!downloadUrl) return null;

    return (
        <a
            href={homeActionUrlPath(downloadUrl)}
            download={true}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => {
                e.stopPropagation();
                onClickDownloadRecording?.();
            }}
        >
            <MenuItem>
                <div className="flex items-center gap-x-2">
                    <Icon iconKey="download" />
                    {i18next.t('call.recording.download')}
                </div>
            </MenuItem>
        </a>
    );
};

export default MenuItemDownloadRecording;
